import { lockBody, unlockBody } from "@plugins";

class FilterPopup {
    constructor(element, options) {
        Object.assign(this);

        const filter = this;

        this._setDefaults(options);

        this.element = element;
        this.openFilterBtn = document.querySelector(".js-filter-btn");
        this.closeFilterBtn = document.querySelector(".filter__btn-close");

        this.isOpen = new Proxy(this.isOpen, {
            set(target, name, val) {
                target[name] = val;

                if (val) {
                    setTimeout(() => {
                        document.addEventListener("click", (e) => {
                            if (
                                e.target !== filter.openFilterBtn &&
                                !e.target.closest(".filter__popup")
                            ) {
                                filter.close(filter.element);
                            }
                        });
                    }, "100");
                }

                return true;
            },
        });

        this.openFilterBtn.addEventListener("click", () => {
            this.open(this.element);
        });

        this.closeFilterBtn.addEventListener("click", () => {
            this.close(this.element);
        });
    }

    _setDefaults(options) {
        const defaults = {
            isOpen: {
                state: false,
            },
        };
        Object.assign(this, defaults, options);
    }

    open(element) {
        if (!this.isOpen.state) {
            this.isOpen.state = true;
            element.classList.remove("collapsed");
            lockBody(this.element, { reserveScrollBarGap: true });
            globalThis.ret.setLabelsWrapGridTemplate();
        }
    }

    close(element) {
        this.isOpen.state = false;
        element.classList.add("collapsed");
        unlockBody();
    }
}

function initFilter(filter) {
    if (window.mobileMedia) {
        const filterBtn = filter.querySelector(".js-filter-btn-mob");
        const filterBtnClose = filter.querySelector(".filter__btn-close");

        if (filterBtn) {
            filterBtn.addEventListener("click", (e) => {
                e.preventDefault();
                filter.classList.remove("collapsed");
                lockBody(filter);
            });
        }

        if (filterBtnClose) {
            filterBtnClose.addEventListener("click", (e) => {
                e.preventDefault();
                filter.classList.add("collapsed");
                unlockBody();
            });
        }
    } else {
        new FilterPopup(filter);
    }
}

const catalogFiter = document.querySelector(".js-filter");

if (catalogFiter) {
    window.addEventListener("load", () => initFilter(catalogFiter));
}
